import { useMutation } from 'react-query';

import { ApplicationFeedService } from '../../../../services/v1/applicant_tracking/ApplicationFeedService';
import { useCallback } from 'react';
import { ApiError } from '../../../../services/ApiService/errors/ApiError';

export const useCancelTriggerExecution = (feedId: string | number) => {
  const { mutateAsync, ...rest } = useMutation(
    ['feed-cancel-trigger-execution', feedId],
    ApplicationFeedService.cancelTriggerExecution,
  );

  const handleCancelTrigger = useCallback(async () => {
    try {
      await mutateAsync(feedId);
      return true;
    } catch (error) {
      if (error instanceof ApiError) {
        if (error.status === 409) {
          return false;
        } else {
          console.error(error);
        }
      } else throw console.error(error);
    }
  }, [mutateAsync]);

  return { handleCancelTrigger, ...rest };
};
